export let GridStrategyGroup = /*#__PURE__*/function (GridStrategyGroup) {
  GridStrategyGroup["DataSource"] = "dataSource";
  GridStrategyGroup["RowTree"] = "rowTree";
  return GridStrategyGroup;
}({});